import React, { useRef, useState, useCallback, useMemo, useEffect } from "react";
import "../css/home.css";
import moment from "moment";
import { Link, useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import {
  FaFilePdf,
  FaFlag,
  FaLaptop,
  FaRegLightbulb,
  FaGraduationCap,
  FaUniversity,
  FaClipboardList,
  FaUserTie,
  FaAngleLeft,
  FaAngleRight,
  FaTimes,
  FaBullseye
} from "react-icons/fa";
import { Row, Col, Modal, ModalBody } from "reactstrap";
import gif from "../assets/new.gif";
import vicechan from "../assets/VC.jpeg";
import Governor from "../assets/governor.png";
import registrar from "../assets/registrarmvsu.jpg";
import BaseUrl from "../base-api";
import Loader from "./Loader/Loader";
import { useNotifications } from "./Dashboard/hooks/useNotifications";
import { Carousel as BootstrapCarousel } from "bootstrap";
// Add your asset image below:
import myImage from "../assets/popup.jpg";

const Home = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const galleryRef = useRef(null);

  // Notifications (custom hook)
  const { notifications, loading: loadingNotifications, handleNotificationClick } = useNotifications("All");
  // Menu items (memoized)
  const menuItems = useMemo(
    () => [
      { text: "ऑनलाइन भुगतान", color: "#f15b2a", icon: <FaLaptop />, path: "" },
      { text: "निविदायें", color: "#d926a9", icon: <FaRegLightbulb />, path: "" },
      { text: "सम्बद्ध महाविद्यालय", color: "#24c4f4", icon: <FaGraduationCap />, path: "" },
      { text: "डिजिटल विश्वविद्यालय", color: "#1dbf73", icon: <FaUniversity />, path: "" },
      { text: "छात्रवृत्ति", color: "#f8484a", icon: <FaClipboardList />, path: "/hi/छात्रवृत्ति" },
      { text: "भर्ती", color: "#fbc02d", icon: <FaUserTie />, path: "" },
      { text: "हर घर तिरंगा", color: "rgb(241, 91, 42)", icon: <FaFlag />, path: "" },
      { text: "AAS", color: "rgb(241, 91, 42)", icon: <FaBullseye />, href: "https://www.mvsuonline.in/aas/" }
    ],
    []
  );

  // Images State & Loading
  const [carouselImages, setCarouselImages] = useState([]);
  const [galleryImages, setGalleryImages] = useState([]);
  const [popup, setPopup] = useState(null);   // ✅ popup ek object ya single image ho सकता है

  const [loadingCarousel, setLoadingCarousel] = useState(true);
  const [loadingGallery, setLoadingGallery] = useState(true);
  const [loadingPopup, setLoadingPopup] = useState(true);


  const [modalImageSrc, setModalImageSrc] = useState(null);
  const [imageModalOpen, setImageModalOpen] = useState(false);


  const [popupOpen, setPopupOpen] = useState(false);
  const togglePopup = useCallback(() => setPopupOpen(o => !o), []);


  useEffect(() => {
    setPopupOpen(true);
  }, []);


  // Fetch images (parallel, non-blocking)
  const fetchImages = useCallback(async (locationName, setImages, setLoading) => {
    setLoading(true);
    try {
      const res = await axios.post(
        `${BaseUrl}/api/v1/files/getImages`,
        { location: locationName },
        { headers: { "Content-Type": "application/json" }, timeout: 10000 }
      );
      if (res.data.status === 200 && Array.isArray(res.data.data.content)) {
        const imgs = res.data.data.content.map((img, idx) => ({
          src: img.file ? `data:image/jpeg;base64,${img.file}` : "",
          key: img.key || idx + 1,
        }));
        setImages(imgs);
      } else {
        setImages([]);
      }
    } catch (error) {
      setImages([]);
    } finally {
      setLoading(false);
    }
  }, []);

  // Fetch images on mount/route change (parallel)
  useEffect(() => {
    fetchImages("Home Corousel", setCarouselImages, setLoadingCarousel);
    fetchImages("Photo Gallery", setGalleryImages, setLoadingGallery);
    fetchImages("Home PoPup", (imgs) => {
      setPopup(imgs.length > 0 ? imgs[0].src : null);
    }, setLoadingPopup);
  }, [location.pathname, fetchImages]);

  // Bootstrap Carousel re-initialization
  useEffect(() => {
    if (carouselImages.length === 0) return;
    const carouselEl = document.getElementById("carouselExampleIndicators");
    if (!carouselEl) return;
    const existingInstance = BootstrapCarousel.getInstance(carouselEl);
    if (existingInstance) existingInstance.dispose();
    new BootstrapCarousel(carouselEl, {
      interval: 4000,
      ride: "carousel",
      wrap: true,
      pause: "hover",
    });
  }, [carouselImages]);

  // Notifications filters (memoized)
  const tenderNotifications = useMemo(() => {
    if (!notifications) return [];
    return notifications
      .filter(item => ["Notice Board", "Events", "Seminar"].includes(item.location))
      .sort((a, b) => new Date(b.createdDate) - new Date(a.createdDate))
      .slice(0, 5);
  }, [notifications]);
  const noticeNotifications = useMemo(
    () => notifications?.filter((n) => n.location === "Notice Board") || [],
    [notifications]
  );
  const eventNotifications = useMemo(
    () => notifications?.filter((n) => n.location === "Events") || [],
    [notifications]
  );
  const seminarNotifications = useMemo(
    () => notifications?.filter((n) => n.location === "Seminar") || [],
    [notifications]
  );

  // Modal handlers (gallery image modal)
  const toggleImageModal = useCallback(() => setImageModalOpen((o) => !o), []);
  const handleImageClick = useCallback((src) => {
    setModalImageSrc(src);
    setImageModalOpen(true);
  }, []);
  const scrollNext = useCallback(() => {
    if (galleryRef.current) {
      galleryRef.current.scrollBy({ left: 300, behavior: "smooth" });
    }
  }, []);
  const scrollPrev = useCallback(() => {
    if (galleryRef.current) {
      galleryRef.current.scrollBy({ left: -300, behavior: "smooth" });
    }
  }, []);
  const handleClick = useCallback(
    (path) => {
      if (path) navigate(path);
    },
    [navigate]
  );

  // Auto-scroll gallery every 3 seconds, loop to start if at end
  useEffect(() => {
    const interval = setInterval(() => {
      const el = galleryRef.current;
      if (el) {
        if (el.scrollWidth <= el.clientWidth) return;
        if (el.scrollLeft + el.clientWidth >= el.scrollWidth - 2) {
          el.scrollTo({ left: 0, behavior: "smooth" });
        } else {
          el.scrollBy({ left: 300, behavior: "smooth" });
        }
      }
    }, 3000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div>
      {/* Popup modal - only on first time (asset image) */}
      <Modal isOpen={!!popup} toggle={() => setPopup(null)} className="modal-dialog-centered modal-lg">
        <div style={{ position: "absolute", right: "20px", top: "10px", zIndex: 2 }}>
          <FaTimes
            style={{
              fontSize: "2rem",
              cursor: "pointer",
              color: "#ff2222"
            }}
            onClick={() => setPopup(null)}   // close on click
            title="Close"
          />
        </div>
        <ModalBody>
          {loadingPopup ? (
            <p>लोड हो रहा है...</p>
          ) : popup ? (
            <img
              src={popup}   // ✅ backend से आने वाला popup image
              alt="Popup"
              style={{ width: "100%", height: "auto", objectFit: "contain" }}
              loading="lazy"
            />
          ) : null}
        </ModalBody>
      </Modal>

      {/* Marquee Section */}
      <div className="container-fluid" style={{ background: "#27a997" }}>
        <Row>
          <Col md={2} style={{ background: "#668bf5cc" }}>
            <h5 className="text-center mt-2" style={{ color: "white" }}>
              महत्वपूर्ण अपडेट
            </h5>
          </Col>
          <Col md={10} className="marquee-container" style={{ backgroundColor: "#39699e" }}>
            {loadingNotifications ? (
              <p style={{ color: "#fff" }}>लोड हो रहा है...</p>
            ) : (
              <div className="marquee-content d-flex align-items-center">
                {tenderNotifications.map((link, index) => (
                  <div
                    key={index}
                    className="carousel-item-content"
                    style={{ paddingRight: "40px" }}
                  >
                    <h5 className="mt-2 d-flex align-items-center" style={{ fontSize: "small" }}>
                      <div
                        onClick={() => handleNotificationClick(link)}
                        style={{
                          cursor: "pointer",
                          color: "#fff",
                          textDecoration: "none",
                          display: "inline-flex",
                          alignItems: "center",
                        }}
                        title={link.title_Hindi}
                      >
                        <span style={{ marginRight: "8px", fontWeight: "bold" }}>
                          {moment(link.created).format("DD-MM-YYYY")}
                        </span>
                        {link.title_Hindi}
                        <FaFilePdf style={{ fontSize: "20px", marginLeft: "5px" }} />
                        <img src={gif} alt="New" style={{ width: "30px", marginLeft: "8px" }} />
                      </div>
                    </h5>
                  </div>
                ))}
              </div>
            )}
          </Col>
        </Row>
      </div>

      {/* Carousel Section */}
      <div
        id="carouselExampleIndicators"
        className="carousel slide"
        data-bs-ride="carousel"
        style={{ width: "100%", overflow: "hidden", height: "330px" }}
      >
        {loadingCarousel ? (
          <div className="d-flex justify-content-center align-items-center" style={{ height: "330px" }}>
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
        ) : carouselImages.length > 0 ? (
          <>
            <div className="carousel-indicators">
              {carouselImages.map((_, index) => (
                <button
                  key={index}
                  type="button"
                  data-bs-target="#carouselExampleIndicators"
                  data-bs-slide-to={index}
                  className={index === 0 ? "active" : ""}
                  aria-label={`Slide ${index + 1}`}
                />
              ))}
            </div>
            <div className="carousel-inner">
              {carouselImages.map((image, index) => (
                <div
                  key={image.key}
                  className={`carousel-item ${index === 0 ? "active" : ""}`}
                  style={{ height: "100%" }}
                >
                  <img
                    src={image.src}
                    className="d-block w-100"
                    alt={`Slide ${index + 1}`}
                    style={{ height: "330px", width: "100%", objectFit: "cover" }}
                    loading={index === 0 ? "eager" : "lazy"}
                  />
                </div>
              ))}
            </div>
            <button
              className="carousel-control-prev"
              type="button"
              data-bs-target="#carouselExampleIndicators"
              data-bs-slide="prev"
            >
              <span className="carousel-control-prev-icon" aria-hidden="true" />
              <span className="visually-hidden">Previous</span>
            </button>
            <button
              className="carousel-control-next"
              type="button"
              data-bs-target="#carouselExampleIndicators"
              data-bs-slide="next"
            >
              <span className="carousel-control-next-icon" aria-hidden="true" />
              <span className="visually-hidden">Next</span>
            </button>
          </>
        ) : (
          <div className="d-flex justify-content-center align-items-center" style={{ height: "330px" }}>
            <span>कोई छवि उपलब्ध नहीं है।</span>
          </div>
        )}
      </div>

      {/* Menu Items */}
      <div
        className="menu-wrapper d-flex flex-wrap justify-content-center align-items-center"
        style={{ backgroundColor: "lightblue", gap: "3.5rem" }}
      >
        {menuItems.map((item, index) => (
          item.href ? (
            // External link (href वाला)
            <a
              key={index}
              href={item.href}
              target="_blank"
              rel="noopener noreferrer"
              className="d-flex flex-column align-items-center px-3 py-1"
              style={{ cursor: "pointer", textDecoration: "none" }}
              title={item.text}
            >
              <div
                className="circle d-flex justify-content-center align-items-center"
                style={{
                  backgroundColor: item.color,
                  borderRadius: "50%",
                  width: "30px",
                  height: "30px",
                  fontSize: "1.2rem",
                  color: "white",
                  transition: "all 0.3s ease-in-out",
                }}
              >
                {item.icon}
              </div>
              <p className="mb-0 fw-bold text-black text-center home-menu-text">
                {item.text}
              </p>
            </a>
          ) : (
            // Internal navigation (path वाला)
            <div
              key={index}
              className="d-flex flex-column align-items-center px-3 py-1"
              style={{ cursor: "pointer" }}
              onClick={() => navigate(item.path)}
              title={item.text}
            >
              <div
                className="circle d-flex justify-content-center align-items-center"
                style={{
                  backgroundColor: item.color,
                  borderRadius: "50%",
                  width: "30px",
                  height: "30px",
                  fontSize: "1.2rem",
                  color: "white",
                  transition: "all 0.3s ease-in-out",
                }}
              >
                {item.icon}
              </div>
              <p className="mb-0 fw-bold text-black text-center home-menu-text">
                {item.text}
              </p>
            </div>
          )
        ))}
      </div>


      {/* Leadership Section */}
      <div style={{ backgroundColor: "#f0f0f0", padding: "3% 0" }}>
        <Row className="pt">
          {[
            {
              src: Governor,
              alt: "Governor",
              title: "महामहिम राज्यपाल प्रो. अशीम कुमार घोष",
              position: "कुलाधिपति",
              path: "/hi/विश्वविद्यालय/कुलाधिपति-संदेश",
            },
            {
              src: vicechan,
              alt: "Vice Chancellor",
              title: "प्रो. राजेंद्र कुमार अनायत",
              position: "कुलपति",
              path: "/hi/विश्वविद्यालय/कुलपति-संदेश",
            },
            {
              src: registrar,
              alt: "Registrar",
              title: "प्रो. संजय कुमार गोयल",
              position: "कुलसचिव",
              path: "/hi/विश्वविद्यालय/कुलसचिव-संदेश",
            },
          ].map(({ src, alt, title, position, path }, idx) => (
            <Col
              key={idx}
              md={4}
              className="text-center"
              onClick={() => handleClick(path)}
              style={{ cursor: "pointer" }}
              title={`${title} - ${position}`}
            >
              <img
                src={src}
                alt={alt}
                className="img-fluid"
                style={{ height: "160px", objectFit: "cover" }}
                loading="lazy"
              />
              <p className="text-center mt-2">
                <strong>{title}</strong>
                <br />
                {position}
              </p>
            </Col>
          ))}
        </Row>
      </div>

      {/* Notifications Section */}
      <div className="container-fluid mt-4 py-4">
        <style>
          {`
            @keyframes scrollUp {
              0% { transform: translateY(100%); }
              100% { transform: translateY(-100%); }
            }
            .scroll-marquee-wrapper {
              position: relative;
              height: 300px;
              overflow: hidden;
            }
            .scroll-marquee {
              display: inline-block;
              animation: scrollUp 30s linear infinite;
            }
            .scroll-marquee-wrapper:hover .scroll-marquee {
              animation-play-state: paused;
            }
          `}
        </style>
        <div className="row">
          {/* Notice Column */}
          <div className="col-12 col-sm-6 col-md-4">
            <h5 style={{ color: "#3c3970", fontSize: "16px" }}>सूचनाएं/समाचार</h5>
            <div
              className="scroll-marquee-wrapper"
              style={{ backgroundColor: "#eff3f6", padding: "20px", borderRadius: "8px" }}
            >
              {loadingNotifications ? (
                <div className="d-flex justify-content-center align-items-center" style={{ height: "100%" }}>
                  <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </div>
                </div>
              ) : (
                <div className="scroll-marquee">
                  {noticeNotifications
                    .sort((a, b) => new Date(b.created) - new Date(a.created)) // latest first
                    .slice(0, 7) // sirf 7 latest notices
                    .map((notice, idx) => (
                      <div
                        key={notice.id || idx}
                        onClick={() => handleNotificationClick(notice)}
                        style={{
                          cursor: "pointer",
                          display: "block",
                          marginBottom: "10px",
                          fontSize: "14px",
                          color: "#000",
                        }}
                        title={notice.title_Hindi || "No Title Available"}
                      >
                        <span
                          style={{
                            display: "inline-block",
                            backgroundColor: "#3c3970",
                            color: "white",
                            padding: "2px 6px",
                            borderRadius: "4px",
                            fontWeight: "bold",
                            marginRight: "8px",
                            fontSize: "12px",
                          }}
                        >
                          {notice.created ? moment(notice.created).format("DD MMM YYYY") : "N/A"}
                        </span>
                        {notice.title_Hindi || "No Title Available"}
                      </div>
                    ))}
                </div>
              )}

            </div>
            <div className="text-center mt-2">
              <button
                className="btn btn-link p-0"
                style={{ fontSize: "14px" }}
                onClick={() => navigate("/hi/सूचनाएं")}
              >
                View All
              </button>
            </div>
          </div>


          {/* Events Column */}
          <div className="col-12 col-sm-6 col-md-4">
            <h5 style={{ color: "#3c3970", fontSize: "16px" }}>गतिविधियाँ</h5>
            <div
              className="scroll-marquee-wrapper"
              style={{ backgroundColor: "#eff3f6", padding: "20px", borderRadius: "8px" }}
            >
              {loadingNotifications ? (
                <div className="d-flex justify-content-center align-items-center" style={{ height: "100%" }}>
                  <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </div>
                </div>
              ) : (
                <div className="scroll-marquee">
                  {eventNotifications.map((notice, idx) => (
                    <div
                      key={notice.id || idx}
                      onClick={() => handleNotificationClick(notice)}
                      style={{
                        cursor: "pointer",
                        display: "block",
                        marginBottom: "10px",
                        fontSize: "14px",
                        color: "#000",
                      }}
                      title={notice.title_Hindi || "No Title Available"}
                    >
                      <span
                        style={{
                          display: "inline-block",
                          backgroundColor: "#3c3970",
                          color: "white",
                          padding: "2px 6px",
                          borderRadius: "4px",
                          fontWeight: "bold",
                          marginRight: "8px",
                          fontSize: "12px",
                        }}
                      >
                        {notice.created ? moment(notice.created).format("DD MMM YYYY") : "N/A"}
                      </span>
                      {notice.title_Hindi || "No Title Available"}
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
          {/* Seminar Column */}
          <div className="col-12 col-sm-6 col-md-4">
            <h5 style={{ color: "#3c3970", fontSize: "16px" }}>सम्मेलन/सेमिनार/कार्यशाला</h5>
            <div
              className="scroll-marquee-wrapper"
              style={{ backgroundColor: "#eff3f6", padding: "20px", borderRadius: "8px" }}
            >
              {loadingNotifications ? (
                <div className="d-flex justify-content-center align-items-center" style={{ height: "100%" }}>
                  <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </div>
                </div>
              ) : (
                <div className="scroll-marquee">
                  {seminarNotifications.map((notice, idx) => (
                    <div
                      key={notice.id || idx}
                      onClick={() => handleNotificationClick(notice)}
                      style={{
                        cursor: "pointer",
                        display: "block",
                        marginBottom: "10px",
                        fontSize: "14px",
                        color: "#000",
                      }}
                      title={notice.title_Hindi || "No Title Available"}
                    >
                      <span
                        style={{
                          display: "inline-block",
                          backgroundColor: "#3c3970",
                          color: "white",
                          padding: "2px 6px",
                          borderRadius: "4px",
                          fontWeight: "bold",
                          marginRight: "8px",
                          fontSize: "12px",
                        }}
                      >
                        {notice.created ? moment(notice.created).format("DD MMM YYYY") : "N/A"}
                      </span>
                      {notice.title_Hindi || "No Title Available"}
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Social Media Section */}
      <h3 className="text-center mb-4" style={{ color: "rgb(60, 57, 112)" }}>
        सोशल मीडिया
      </h3>
      <div className="row bg-light p-4 rounded mx-0 text-center">
        {/* Facebook */}
        <div className="col-md-6 mb-6">
          <div className="card py-3 px-5 home-social-card">
            <div className="px-4">
              <iframe
                title="MVSU Facebook Page"
                src="https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2FMVSUOfficial&tabs=timeline&width=600&height=300&small_header=true&adapt_container_width=true&hide_cover=false&show_facepile=true"
                height={300}
                width="100%"
                scrolling="no"
                frameBorder="0"
                allowFullScreen={true}
                allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
                loading="lazy"
              />
            </div>
            <p className="mt-2 mb-0 text-center">फेसबुक</p>
          </div>
        </div>
        {/* YouTube */}
        <div className="col-md-6 mb-6">
          <div
            className="card py-3 px-5 d-flex flex-column justify-content-center align-items-center home-social-card"
          >
            <a
              href="https://www.youtube.com/@mvsuofficial"
              target="_blank"
              rel="noopener noreferrer"
              style={{ textDecoration: "none", color: "inherit", textAlign: "center" }}
              title="MVSU YouTube Channel"
            >
              <img
                src="https://upload.wikimedia.org/wikipedia/commons/4/42/YouTube_icon_%282013-2017%29.png"
                alt="MVSU YouTube Channel"
                style={{ width: "150px", maxHeight: "150px", objectFit: "contain", marginBottom: "10px" }}
              />
              <p className="mb-0">यूट्यूब</p>
            </a>
          </div>
        </div>
      </div>

      {/* Gallery Section */}
      <div className="container-fluid py-2" style={{ background: "#689c97" }}>
        <h3 className="text-center font-weight-bold mb-4" style={{ color: "white" }}>
          गैलरी
        </h3>
        {loadingGallery ? (
          <div className="text-center py-5">
            <div className="spinner-border text-light" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
        ) : galleryImages.length > 0 ? (
          <div className="gallery-content" style={{ position: "relative" }}>
            <div
              className="gallery-wrapper mx-auto"
              style={{ overflow: "hidden", position: "relative" }}
              onMouseEnter={e =>
                (e.currentTarget.querySelector(".gallery-arrow").style.display = "flex")
              }
              onMouseLeave={e =>
                (e.currentTarget.querySelector(".gallery-arrow").style.display = "none")
              }
            >
              <div
                className="gallery-track"
                ref={galleryRef}
                style={{
                  display: "flex",
                  overflowX: "auto",
                  scrollBehavior: "smooth",
                  scrollbarWidth: "none",
                  msOverflowStyle: "none",
                  transition: "scroll 2s ease",
                }}
              >
                <Row className="gallery-row flex-nowrap" style={{ margin: 0 }}>
                  {galleryImages.map((image, idx) => (
                    <Col
                      sm="2"
                      className="px-1 home-gallery-col"
                      key={image.key || idx}
                      onClick={() => handleImageClick(image.src)}
                      style={{ cursor: "pointer" }}
                      title={`Gallery Image ${idx + 1}`}
                    >
                      <img
                        src={image.src}
                        alt={`Gallery Image ${idx + 1}`}
                        className="home-gallery-img"
                        loading="lazy"
                      />
                    </Col>
                  ))}
                </Row>
              </div>
              <div
                className="gallery-arrow"
                style={{
                  display: "none",
                  position: "absolute",
                  top: "50%",
                  width: "100%",
                  transform: "translateY(-50%)",
                  justifyContent: "space-between",
                }}
              >
                <div
                  onClick={scrollPrev}
                  style={{
                    cursor: "pointer",
                    padding: "10px",
                    background: "rgba(0, 0, 0, 0.5)",
                    color: "#fff",
                    userSelect: "none",
                  }}
                  aria-label="Scroll gallery left"
                >
                  <FaAngleLeft />
                </div>
                <div
                  onClick={scrollNext}
                  style={{
                    cursor: "pointer",
                    padding: "10px",
                    background: "rgba(0, 0, 0, 0.5)",
                    color: "#fff",
                    userSelect: "none",
                  }}
                  aria-label="Scroll gallery right"
                >
                  <FaAngleRight />
                </div>
              </div>
            </div>
          </div>
        ) : (
          <p className="text-center text-light">कोई गैलरी छवियां उपलब्ध नहीं हैं।</p>
        )}
        <div className="d-flex justify-content-end me-4">
          <Link className="btn btn-danger mt-3" to="/hi/gallery">
            सभी तस्वीरें देखें
          </Link>
        </div>
      </div>

      {/* Gallery image modal */}
      <Modal isOpen={imageModalOpen} toggle={toggleImageModal} className="modal-dialog-centered modal-lg">
        <ModalBody>
          {modalImageSrc && (
            <img
              src={modalImageSrc}
              alt="Modal"
              style={{ width: "100%", height: "auto", objectFit: "contain" }}
              loading="lazy"
              onClick={toggleImageModal}
              role="button"
              tabIndex={0}
            />
          )}
        </ModalBody>
      </Modal>
    </div>
  );
};

export default Home;
